import { VenueBranch } from '@inplay/models';
import { AuthTokenResponse } from '../../service/service.type';
import {
  GroupedOrganizationUnit,
  GroupedOrganizationType,
  GroupedSubOrganizationType,
  GroupedVenueType,
  GroupedBranchType,
} from '../../service/context/organizationContext.types';

export type PageHeaderProps = {
  title: string;
  username: string;
  onHamburgerClick: () => void;
  isSidebarOpen: boolean;
};

export type VenueDropdownProps = {
  decodedLoginData: AuthTokenResponse | null;
  groupedOrganizationData: GroupedOrganizationUnit | undefined;
  selectedVenueBranch: (VenueBranch & { _id: string }) | undefined;
  updateSelectedVenueBranch: (branch: VenueBranch & { _id: string }) => void;
};

export type expandHierarchy = {
  organization: string | undefined;
  subOrganization: string | undefined;
  venue: string | undefined;
};

export type SearchResults = {
  organization: string[];
  subOrganization: string[];
  venue: string[];
  venueBranches: string[];
};

export enum VenueHierarchyLevel {
  ORGANIZATION = 'organization',
  SUB_ORGANIZATION = 'subOrganization',
  VENUE = 'venue',
  VENUE_BRANCH = 'venueBranch',
}

export type HierarchyLevelAndItems =
  | {
      level: VenueHierarchyLevel.ORGANIZATION;
      items: GroupedOrganizationType[];
    }
  | {
      level: VenueHierarchyLevel.SUB_ORGANIZATION;
      items: GroupedSubOrganizationType[];
    }
  | {
      level: VenueHierarchyLevel.VENUE;
      items: GroupedVenueType[];
    }
  | {
      level: VenueHierarchyLevel.VENUE_BRANCH;
      items: GroupedBranchType[];
    };

export type RenderCollapseHierarchyProps =
  | ({
      level: VenueHierarchyLevel.ORGANIZATION;
      items: GroupedOrganizationType[];
    } & BaseCollapseProps)
  | ({
      level: VenueHierarchyLevel.SUB_ORGANIZATION;
      items: GroupedSubOrganizationType[];
    } & BaseCollapseProps)
  | ({
      level: VenueHierarchyLevel.VENUE;
      items: GroupedVenueType[];
    } & BaseCollapseProps)
  | ({
      level: VenueHierarchyLevel.VENUE_BRANCH;
      items: GroupedBranchType[];
    } & BaseCollapseProps);

type BaseCollapseProps = {
  expandHierarchy: {
    organization?: string;
    subOrganization?: string;
    venue?: string;
  };
  searchResults: {
    organization: string[];
    subOrganization: string[];
    venue: string[];
    venueBranches: string[];
  };
  searchQuery: string;
  onBranchSelect: (branch: VenueBranch & { _id: string }) => void;
  selectedVenueBranch?: VenueBranch & { _id: string };
};
